var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export default class DataColumnActions {
    constructor(upsertCallback = null, resetCallback = null, deleteCallback = null) {
        this._upsertCallback = upsertCallback;
        this._resetCallback = resetCallback;
        this._deleteCallback = deleteCallback;
    }
    upsert(column) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            if (this._upsertCallback) {
                this._upsertCallback(column);
                return;
            }
            column.isLoading = true;
            try {
                column.entity = (_b = yield ((_a = column.entity) === null || _a === void 0 ? void 0 : _a.save())) !== null && _b !== void 0 ? _b : null;
                (_c = column.entity) === null || _c === void 0 ? void 0 : _c.for(null);
                (_d = column.entity) === null || _d === void 0 ? void 0 : _d.recalculateFormulaFields();
            }
            catch (error) {
                console.error(error);
            }
            column.isLoading = false;
            column.isEditing = false;
        });
    }
    reset(column) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            if (this._resetCallback) {
                this._resetCallback(column);
                return;
            }
            const Constructor = Object.getPrototypeOf(column.entity).constructor;
            if (!Constructor) {
                throw new Error('Entity must be set!');
            }
            column.isLoading = true;
            if ((_a = column.entity) === null || _a === void 0 ? void 0 : _a.id) {
                try {
                    column.entity = yield Constructor.$find(column.entity.id);
                    (_b = column.entity) === null || _b === void 0 ? void 0 : _b.recalculateFormulaFields();
                }
                catch (error) {
                    console.error(error);
                }
            }
            else {
                column.entity = new Constructor({ store_id: (_c = column.entity) === null || _c === void 0 ? void 0 : _c.store_id, date: (_d = column.entity) === null || _d === void 0 ? void 0 : _d.date });
            }
            column.isLoading = false;
            column.isEditing = false;
        });
    }
    destroy(column) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            if (this._deleteCallback) {
                this._deleteCallback(column);
                return;
            }
            const Constructor = Object.getPrototypeOf(column.entity).constructor;
            if (!Constructor) {
                throw new Error('Entity must be set!');
            }
            const newEntity = new Constructor({ store_id: (_a = column.entity) === null || _a === void 0 ? void 0 : _a.store_id, date: (_b = column.entity) === null || _b === void 0 ? void 0 : _b.date });
            column.isLoading = true;
            if ((_c = column.entity) === null || _c === void 0 ? void 0 : _c.id) {
                try {
                    yield column.entity.delete();
                    column.entity = newEntity;
                }
                catch (error) {
                    console.error(error);
                }
            }
            else {
                column.entity = newEntity;
            }
            column.isLoading = false;
            column.isEditing = false;
        });
    }
    get upsertCallback() {
        return this._upsertCallback;
    }
    set upsertCallback(value) {
        this._upsertCallback = value;
    }
    get resetCallback() {
        return this._resetCallback;
    }
    set resetCallback(value) {
        this._resetCallback = value;
    }
    get deleteCallback() {
        return this._deleteCallback;
    }
    set deleteCallback(value) {
        this._deleteCallback = value;
    }
}
